import React, { CSSProperties, MouseEventHandler } from 'react';
import { i18n } from 'src/common';
import { Button, Flex } from 'src/components';

interface NavigationButtonsProps {
  handleBack: MouseEventHandler<HTMLButtonElement>;
  handleNext: MouseEventHandler<HTMLButtonElement>;
  backText?: string;
  nextText?: string;
  gap?: number;
  style?: CSSProperties;
  /** Disables the forward button (e.g. while a captcha challenge waits to be solved). */
  nextDisabled?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  handleBack,
  handleNext,
  backText = i18n.t('common.back'),
  nextText = i18n.t('common.next'),
  gap = 64,
  style,
  nextDisabled = false,
}) => (
  <Flex gap={gap} align="center" justify="flex-end" style={style}>
    <Button
      text={backText}
      btnType="textBlack"
      size="large"
      onClick={handleBack}
      style={{ paddingLeft: 8 }}
    />
    <Button
      text={nextText}
      btnType="primary"
      size="large"
      onClick={handleNext}
      disabled={nextDisabled}
      style={{ flex: '1 0 0' }}
    />
  </Flex>
);
